<div class="queue-card"
     [class.queue-card--inactive]="!queue.isActive"
     (click)="onClick()">

  <div class="queue-card__top-bar"
       [class.queue-card__top-bar--inactive]="!queue.isActive">
  </div>

  <div class="queue-card__body p-3">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h5 class="queue-card__name fs-6 fw-semibold mb-0">{{ queue.name }}</h5>
      <span class="queue-card__badge small d-inline-flex align-items-center text-nowrap rounded-pill fw-medium"
            [class.queue-card__badge--active]="queue.isActive"
            [class.queue-card__badge--inactive]="!queue.isActive">
        <span class="queue-card__dot rounded-circle flex-shrink-0"></span>
        {{ (queue.isActive ? 'Settings::Queues:Active' : 'Settings::Queues:Inactive') | abpLocalization }}
      </span>
    </div>

    <p
      class="queue-card__description small mb-3"
      [class.queue-card__description--empty]="!queue.description">
      {{ queue.description || '\u00a0' }}
    </p>

    <div class="queue-card__details d-grid">
      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:Routing' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium">{{ routingLabel | abpLocalization }}</span>
      </div>

      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:Priority' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium d-inline-flex align-items-center gap-1">
          {{ priorityLabel | abpLocalization }}
        </span>
      </div>

      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:CallPriority:Title' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium">{{ callPriorityLabel | abpLocalization }}</span>
      </div>

      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:Agents' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium d-inline-flex align-items-center gap-1">
          {{ queue.assignedAgentCount }} {{ 'Settings::Queues:Assigned' | abpLocalization }}
          <i
            *ngIf="queue.assignedAgentCount === 0"
            class="pi pi-exclamation-triangle text-warning"
            [pTooltip]="'Settings::Queues:NoAgentsWarningTooltip' | abpLocalization"
            tooltipPosition="top">
          </i>
        </span>
      </div>

      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:MaxResponseTime:Short' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium">{{ maxResponseTime }} {{ 'Settings::Queues:MaxResponseTime:Unit' | abpLocalization }}</span>
      </div>

      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::Queues:SlaTarget:Short' | abpLocalization }}</span>
        <span class="queue-card__value small fw-medium">{{ slaTargetSeconds }} {{ 'Settings::Queues:SlaTarget:Unit' | abpLocalization }}</span>
      </div>
    </div>

    <div class="queue-card__wrapup mt-auto" *ngIf="queue.wrapUpCodes?.length">
      <hr class="queue-card__wrapup-divider" />
      <div class="d-flex flex-column">
        <span class="queue-card__label small fw-bold text-uppercase mb-1">{{ 'Settings::WorkEnvironment:WrapupCodes:Title' | abpLocalization }}</span>
        <div class="d-flex flex-wrap gap-1 align-items-center">
          <span
            *ngFor="let code of getWrapUpCodesInline()"
            [pTooltip]="code.name"
            tooltipPosition="top"
            appendTo="body"
            class="badge queue-badge rounded-pill small text-truncate mw-100 cursor-pointer">
            {{ code.name }}
          </span>
          <span
            *ngIf="hasWrapUpCodesOverflow()"
            [pTooltip]="getWrapUpCodesOverflowTooltip()"
            tooltipPosition="top"
            appendTo="body"
            class="badge queue-badge rounded-pill small cursor-pointer">
            +{{ getWrapUpCodesOverflowCount() }}
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="queue.declineReasons?.length" class="mt-2">
      <span class="queue-card__label small fw-bold text-uppercase mb-1 d-block">{{ 'Queue::DeclineReasons' | abpLocalization }}</span>
      <div class="d-flex flex-wrap gap-1 align-items-center">
        <span
          *ngFor="let r of getDeclineReasonsInline(queue.declineReasons)"
          [pTooltip]="r.name"
          tooltipPosition="top"
          appendTo="body"
          class="badge queue-badge rounded-pill small text-truncate mw-100 cursor-pointer">
          {{ r.name }}
        </span>
        <span
          *ngIf="hasDeclineReasonOverflow(queue.declineReasons)"
          [pTooltip]="getDeclineReasonsTooltip(queue.declineReasons)"
          tooltipPosition="top"
          appendTo="body"
          class="badge queue-badge rounded-pill small cursor-pointer">
          +{{ getDeclineReasonOverflowCount(queue.declineReasons) }}
        </span>
      </div>
    </div>
  </div>
</div>